import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TabsModule } from 'primeng/tabs';
import { ButtonModule } from 'primeng/button';
import { ButtonViewComponent } from './components/button-view/button-view.component';
import { InputViewComponent } from './components/input-view/input-view.component';
import { SelectViewComponent } from './components/select-view/select-view.component';
import { TableViewComponent } from './components/table-view/table-view.component';
import { MenuViewComponent } from './components/menu-view/menu-view.component';
import { TagViewComponent } from './components/tag-view/tag-view.component';
import { FileListViewComponent } from './components/file-list-view/file-list-view.component';
import { EmptyListViewComponent } from './components/empty-list-view/empty-list-view.component';
import { DatepickerRangeViewComponent } from './components/datepicker-range-view/datepicker-range-view.component';
import { UploadfileViewComponent } from './components/uploadfile-view/uploadfile-view.component';
import { TextareaViewComponent } from './components/textarea-view/textarea-view.component';
import { ToggleSwitchViewComponent } from './components/toggle-switch-view/toggle-switch-view.component';
import { InfoBlockViewComponent } from './components/info-block-view/info-block-view.component';
import { SelectButtonViewComponent } from './components/select-button-view/select-button-view.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DataListViewComponent } from './components/data-list-view/data-list-view.component';
import { CounterViewComponent } from './components/counter-view/counter-view.component';
import { TabViewComponent } from './components/tab-view/tab-view.component';
import { ToggleButtonViewComponent } from './components/toggle-button-view/toggle-button-view.component';
import { MessageViewComponent } from './components/message-view/message-view.component';
import { ChipViewComponent } from './components/chip-view/chip-view.component';
import { PaTabComponent } from 'src/app/shared/ui-kit/pa-tab/pa-tab.component';
import { FiltersViewComponent } from './components/filters-view/filters-view.component';
import { BulkActionsBarViewComponent } from './components/bulk-actions-bar-view/bulk-actions-bar-view.component';
import { EditorViewComponent } from './components/editor-view/editor-view.component';
import { PvzAddressInputViewComponent } from './components/pvz-address-input-view/pvz-address-input-view.component';
import { SlideRangeViewComponent } from './components/slide-range-view/slide-range-view.component';
import { StepperViewComponent } from './components/stepper-view/stepper-view.component';
import { SummaryCardsViewComponent } from './components/summary-cards-view/summary-cards-view.component';

@Component({
  selector: 'app-ui-kit',
  templateUrl: './ui-kit.component.html',
  styleUrls: ['./ui-kit.component.scss'],
  standalone: true,
  imports: [
    TabsModule,
    ButtonModule,
    ButtonViewComponent,
    InputViewComponent,
    SelectViewComponent,
    TableViewComponent,
    MenuViewComponent,
    TagViewComponent,
    FileListViewComponent,
    EmptyListViewComponent,
    DatepickerRangeViewComponent,
    UploadfileViewComponent,
    TextareaViewComponent,
    ToggleSwitchViewComponent,
    InfoBlockViewComponent,
    SelectButtonViewComponent,
    DataListViewComponent,
    CounterViewComponent,
    TabViewComponent,
    ToggleButtonViewComponent,
    MessageViewComponent,
    ChipViewComponent,
    BulkActionsBarViewComponent,
    EditorViewComponent,
    PvzAddressInputViewComponent,
    SlideRangeViewComponent,
    StepperViewComponent,
    PaTabComponent,
    FiltersViewComponent,
    SummaryCardsViewComponent,
  ],
})
export class UiKitComponent implements OnInit {
  activeTab = '0';
  private readonly destroy = inject(DestroyRef);

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
  ) {}

  ngOnInit(): void {
    this.route.queryParamMap.pipe(takeUntilDestroyed(this.destroy)).subscribe((params) => {
      this.activeTab = params.get('tab') ?? this.activeTab;
    });
  }

  handleTabChange(value: unknown): void {
    this.router.navigate([], {
      queryParams: { tab: value },
      queryParamsHandling: 'merge',
      replaceUrl: true,
    });
  }
}
